module.exports = __webpack_public_path__ + "static/img/1-1.6c5fda4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/1-1.png
// module id = S4UI
// module chunks = 0